export default __webpack_public_path__ + "static/media/ic_informacion_de_programas_home_pro.18bbe778.svg";